/**
 * ----------------------------------------------------------------------------------------------
 * individual JS for Cart Page
 * ----------------------------------------------------------------------------------------------
 */

// 2023.1.30 Add start : デッキ一括追加から選択した際のアラート表示
window.addEventListener('DOMContentLoaded', () => {
  let alert_from_deck_bulk_purchase = localStorage.getItem('alert_from_deck_bulk_purchase');
  if(alert_from_deck_bulk_purchase){
    let insertHTML = `<div class="c-cart-alert">`;
    alert_from_deck_bulk_purchase = JSON.parse(alert_from_deck_bulk_purchase);
    alert_from_deck_bulk_purchase.forEach(product => {
      insertHTML += `<p class="c-cart-alert__msg">『${product}』の在庫が不足しているため、カートに追加できませんでした。</p>`;
    });
    insertHTML += `</div>`;

    document.querySelector('.c-cart-card').insertAdjacentHTML('afterbegin',insertHTML);
  }
  localStorage.removeItem('alert_from_deck_bulk_purchase');

  // 2023.2.6 Add start : delete "collection_layout" property from cart attributes
  const cart_attributes = JSON.parse(document.querySelector('[data-section-type="cart"]').dataset.cart_attributes);

  if(cart_attributes.hasOwnProperty('collection_layout')){
    const formData = {
      attributes: {
        "collection_layout":null
      }
    };

    fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'dataType': 'json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })

      .then(data => data.json())
      .then(data => {
        //成功時の処理
        console.log(data)
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }
  // 2023.2.6 Add end : delete "collection_layout" property from cart attributes
})
// 2023.1.30 Add end : デッキ一括追加から選択した際のアラート表示

const clearCart = (e) =>{
  fetch('/cart/clear.js', {
      method: 'POST',
      headers: {
        'dataType': 'json',
        'Content-Type': 'application/json'
      },
      body: ""
    })

    .then(data => data.json())
    .then(data => {
      //成功時の処理
      console.log(data);
      location.reload();
    })
    .catch((error) => {
      console.error('Error:', error);
    });
}